import { PromoterModel } from './PromoterModel';
import { CampaignType } from './CampaignsModel';
import PageModel from './PageModel';

export interface IAutomationStats {
  contactsCount: number;
  inQueueCount: number;
  inAutomationCount: number;
  finishedCount: number;
  messagesSentCount: number;
  unsubscribedCount: number;
  engagedCount: number;
}

export type IAggregateAutomationStats = IAutomationStats & {
  automationsCount: number;
};

export enum EAutomationAction {
  WAIT,
  SEND_SMS,
  SEND_EMAIL,
  CONDITION,
  ZAPIER,
  TAG,
  JSON_WEBHOOK,
  MAILCHIMP,
  GOOGLE_SHEET,
  UNICORN_DETECTOR,
  FACEBOOK_ADS,
}

export const EAutomationActionCategory = {
  message: 'Contact Options',
  rules: 'Rules',
  notifications: 'Notifications',
  crm: 'CRM',
};

export type EAutomationActionCategoryType =
  typeof EAutomationActionCategory[keyof typeof EAutomationActionCategory];

export type IAutomationActionToOpenOnReady = {
  id?: EAutomationAction;
  dialogueId?: number;
  widgetId: number;
};

export type IAutomationAction = {
  dialogueId: number;
  campaignId?: number;
  sortOrder: number;
  pageGroupId?: number;
  widgetId?: number;
  position?: 'before' | 'after';
  isUnicornPath?: boolean;
};

// activeAutomations - automations in which trigger or page is used
export type IAutomationExistingInputTriggers = {
  welcomePage: PageModel & { activeAutomations?: CampaignType[] };
  promoters: (PromoterModel & { activeAutomations?: CampaignType[] })[]; // welcome_page instagram_welcomer instagram_catch_all facebook_catch_all
};
